<template>
    <div class="am-bill-now-modal">
    <a href="javascript:void(0)" @click="billnowPopup" title="Bill Now">
        <svg-icon icon="forward" class="am-glyphicon-medium am-glyphicon-white" title="Bill Now"></svg-icon>
    </a>
    <modal name="bill-now" :clickToClose="false" width="600px" :scrollable="true" :pivotY="0.4" height="auto" :adaptive="true" classes="am-vue-modal">
    <div class="am-bill-now">
        <div class="am-bill-now-title-bar am-main-top-box">
            <span class="am-bill-now-title am-main-top-box-title"><strong>Bill Now</strong></span>
        </div>
            <table class="am-bill-now-table">
                <tbody>
                    <tr>
                        <strong><span>Category:</span></strong>
                        <td>
                            <div>
                                <select v-model="payment.billingType" @change="isValid.billingType = true">
                                  <option value=0>-Select Category-</option>
                                    <option v-for="billing in billingTypes" :value="{name: billing.name, value:billing.value}" :key="billing.value">{{billing.name}}</option>
                                </select>
                            </div>
                            <div class='am-field-error' v-if="isValid.billingType && payment.billingType == 0">
                                Billing Type is Required
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <strong><span>Description:</span></strong>
                        <td>
                            <input v-model="payment.description" type="text">
                        </td>
                    </tr>
                    <tr>
                        <strong><span>Transaction Type:</span></strong>
                        <td>
                            <div>
                            <select v-model="payment.tranCode" @change="toggleForTransaction">
                                <option v-for="transaction in tranCodes" :value="transaction.value" :key="transaction.value">{{transaction.name}}</option>
                            </select>
                            </div>
                            <div class='am-field-error' v-if="isValid.tranCode && payment.tranCode === 0">
                                Transaction Type is Required
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <strong><span>Amount:</span></strong>
                        <td>
                            <div class="am-bill-now-number">
                            <input type="text" placeholder='0' v-model="payment.amount" @keypress="isValid.amount = true,isNumber($event, payment.amount)" >
                            </div>
                            <div class="am-field-error" v-if="isValid.amount && payment.amount === ''">
                                Amount is Required
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <strong><span>Payment Method:</span></strong>
                        <td>
                            <div>
                                <select v-model="payment.paymentMethod" @change="toggleValues">
                                    <option value=0>-Select a Payment Method-</option>
                                    <option v-for="paymentMethod in paymentMethods" :value="{id: paymentMethod.id, account:paymentMethod.account, payment_type:paymentMethod.payment_type}" :key="paymentMethod.id">{{paymentMethod.account}}</option>
                                </select>
                            </div>
                            <div class='am-field-error' v-if="isValid.paymentMethod && payment.paymentMethod === 0">
                                Payment Method is Required
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        <div class="am-bill-now-blue-border"></div>
        <div class="am-bill-now-align-bottom-buttons">
            <div class="am-bill-now-float-right">
                <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
                <div class="am-bill-now-divider"></div>
                <button type="button" class="btn btn-primary" @click="submitBill()">Submit</button>
            </div>
        </div>
        </div>
    </modal>
    </div>
</template>

<script>
import api from './../http'
export default {
  name: 'BillNow',
  data: function () {
    return {
      isValid: {
        billingType: false,
        tranCode: false,
        amount: false,
        paymentMethod: false
      },
      payment: {
        billingType: {
          value: 0,
          name: ''
        },
        description: '',
        tranCode: {
          type: Number,
          default: 0
        },
        amount: '',
        paymentMethod: {
          id: 0,
          account: '',
          payment_type: ''
        },
        employeeId: this.$store.state.auth.user.id
      },
      billingTypes: [
        {
          name: 'Billing',
          value: 1
        },
        {
          name: 'Refund',
          value: 2
        },
        {
          name: 'Void',
          value: 3
        }
      ],
      tranCodes: [
        {
          name: '-Select Transaction Type-',
          value: 0
        },
        {
          name: 'Debit',
          value: 27
        },
        {
          name: 'Refund',
          value: 22
        }
      ],
      paymentMethods: []
    }
  },

  props: {
    accountId: {
      type: Number,
      default: 0
    }
  },

  mounted() {
    this.loadPayments()
  },

  asyncComputed: {
    validUser: {
      get () {
        return this.$store.dispatch('auth/accountingUser').then(function () {
          return true;
        })
      },
      default: false
    }
  },

  methods: {
    async loadPayments() {
      try {
        let response = await api.authenticated().then(() => {
          return api.makeRequest('backoffice/paymentMethods/' + this.accountId)
        })

        if (response.data.results) {
          this.paymentMethods = response.data.results
        }
      } catch (error) {
        this.$log.error('Payments-Log-Failure', error)
        this.paymentMethods = []
      }
    },
    closeModal () {
      this.$modal.hide('bill-now')
    },

    billnowPopup () {
      if (this.validUser === true) {
        this.$modal.show('bill-now')
        this.resetValues()
      }
    },

    submitBill () {
      if (this.validateForm()) {
        let self = this
        api.postRequest('backoffice/billNow/' + this.accountId, this.payment).then(function (response) {
          self.closeModal()
          location.reload()
        })
      }
    },

    resetValues () {
      this.payment = {
        billingType: 0,
        description: '',
        tranCode: 0,
        amount: '',
        paymentMethod: 0,
        employeeId: this.$store.state.auth.user.id
      }
      this.isValid = {
        billingType: false,
        tranCode: false,
        amount: false,
        paymentMethod: false
      }
    },

    displayErrors () {
      if (this.payment.billingType === 0) {
        this.isValid.billingType = true
      }
      if (this.payment.paymentMethod === 0) {
        this.isValid.paymentMethod = true
      }
      if (this.payment.amount === '') {
        this.isValid.amount = true
      }
      if (this.payment.trpanCode === 0) {
        this.isValid.tranCode = true
      }
    },

    validateForm () {
      this.displayErrors()
      return (
        this.payment.billingType !== 0 &&
          this.payment.paymentMethod !== 0 &&
          this.payment.amount !== '') &&
          this.payment.tranCode !== 0
    },

    toggleValues () {
      if (this.payment.paymentMethod === 0) {
        this.isValid.paymentMethod = true
      }
    },

    toggleForTransaction () {
      this.isValid.tranCode = true
      this.isValid.amount = false
      this.payment.amount = ''
    },
    isNumber (event, value) {
      event = (event) || window.event
      var charCode = (event.which) ? event.which : event.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault()
      } else if (charCode === 46 && value.includes('.')) {
        event.preventDefault()
      } else {
        return true
      }
    }
  }
}
</script>

<style scoped>
    .am-field-error {
        color: #ff6e40;
    }

    .am-bill-now{
        width:650px;
        border: 1px lightgrey solid;
        color:black;
    }

    .am-bill-now-title-bar {
        height: 35px;
    }
    .am-bill-now-title {
        color: #FDFEFE;
        float: left;
        margin-top: 7px;
        margin-left: 15px;
        font-size: 14px;
    }
    .am-bill-now-table {
        margin-left: 15px;
        margin-right: 40px;
        margin-top: 10px;
    }

    .am-bill-now-table td {
        padding: 5px 0px 0px 20px;
    }
    .am-bill-now-table td input, select{
        width: 350px;
        height:25px;
        margin-top: 5px;
        background-color: white;
    }

    .am-bill-now-table tr span {
        display:block;
        margin-top: 10px;
    }

    .am-bill-now-blue-border {
        display: block;
        width: 100%;
        border-top: 1px solid #4297d7;
        margin-top: 20px;
    }

    .am-bill-now-align-bottom-buttons button{
        margin-top: 5px;
        margin-bottom: 5px;
    }
    .am-bill-now-float-right {
        margin-left: 430px;
    }

    .am-bill-now-divider   {
        width:5px;
        display:inline-block;
    }

    .am-bill-now-modal{
        float:left;
        display:block;
        padding: 0px 3px 0px 0px
    }

    .am-bill-now-number input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
    }
    .v--modal-overlay {
      background-color: rgba(0,0,0,0.6) !important;
    }

</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>
